
import Vue from 'vue'
import { Dropdown, Btn } from 'uiv'

export default Vue.extend({
   name: 'TagInput',
   props: {
      id: { type: String, default: '' },
      value: { type: Array as () => string[], default: () => [] },
      placeholder: { type: String, default: '' },
   },
   data() {
      return {
         inputText: '',
         initialValue: [] as string[],
         innerValue: [] as string[],
      }
   },
   computed: {
      returnValue(): string[] {
         if (this.inputText.trim().length > 0) {
            return [...this.innerValue, this.inputText.trim()]
         } else {
            return this.innerValue
         }
      },
   },
   mounted() {
      if (this.value) {
         this.innerValue = this.value
         this.initialValue = this.value
      }
   },
   methods: {
      createTag(event: any) {
         this.innerValue.push(this.inputText.trim())
         this.inputText = ''
         event.preventDefault()
      },
      removeTag(tag: string) {
         this.innerValue.remove(tag)
      },
   },
   watch: {
      value(newValue: string[]) {
         // Update our inner value if the bind source data changes
         if (!this.innerValue.containsSameElementsAs(newValue)) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
      innerValue(event: any) {
         this.$emit('input', this.innerValue)
         this.$emit('change', this.innerValue)
      },
   },
})
